module.exports = __webpack_public_path__ + "static/media/bannerImage.49347ac1.jpg";